/**
 * The kinds of search result action, mirroring the `type` each
 * App\Http\Resources\Search\*SearchResultAction subclass serializes.
 */
const INTERNAL_LINK = 'internal_link'
const EXTERNAL_LINK = 'external_link'
const REQUEST = 'request'

export default Object.freeze({
    INTERNAL_LINK,
    EXTERNAL_LINK,
    REQUEST,
})
